/*
 * @Description: 谷仓-客户管理模块
 * @Author: cxh
 * @Date: 2022-06-13 16:49:55
 * @LastEditTime: 2023-06-30 17:28:13
 * @LastEditors: cxh
 */
import request from '@/utils/request'
import { AxiosResult, TYCSearchParams } from '@/typings/common'

/**
 * ------------------------------------潜在客户----------------------
 */
/**
 *潜在客户列表
 */
export function potentialList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/findByPage', data)
}
/**
 *转化记录
 */
export function conversionList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/conversion/log/page/list', data)
}
/**
 *潜在客户列表联系人
 */
export function potentialConcatList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/findByPage', data)
}
/**
 *潜在客户发送注册链接邮箱
 */
export function sentEmail(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/sentEmail', data)
}
/**
 *潜在客户发送注册链接电话号吗
 */
export function sentRegisterLink(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/send/register/link', data)
}
export function customerInvalid(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/change/invalid', data)
}
/**
 *删除
 */
export function potentialDel(data: any) {
  return request.delete<AxiosResult, AxiosResult>('/lbu/api/customer/delete', { data })
}
/**
 *新增
 */
export function potentialAdd(data: any, custom: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer', data, custom)
}
/**
 *修改
 */
export function potentialEdit(data: any, custom: any) {
  return request.put<AxiosResult, AxiosResult>('/lbu/api/customer', data, custom)
}

/**
 *转移客户
 */
export function potentialTransfer(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/transfer', data)
}
/**
 *详情
 */
export function potentialDetail(cosId: any) {
  return request.get<AxiosResult, AxiosResult>(`/lbu/api/customer/${cosId}`)
}
/**
 *客户合并
 */
export function customerMerge(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/merge', data)
}
/**
 *获取客户联系人下拉列表
 */
export function customerContactSelect(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/contact/getContacts', data)
}
/**
 *获取客户联系人列表
 */
export function customerContactList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/contact/page/list', data)
}
/**
 *获取客户联系人编辑
 */
export function customerContactEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/contact/update', data)
}
/**
 *获取客户联系人新增
 */
export function customerContactAdd(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/contact/create', data)
}
/**
 *获取客户联系人删除
 */
export function customerContactDelete(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/contact/delete', data)
}

/**
 *获取客户下拉列表
 */
export function findCusNameRelByPage(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/findCusNameRelByPage', data)
}
/**
 *客户转签约
 */
export function turnedContract(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/turnedContract', data)
}
/**
 *客户转成交
 */
export function turnedDeal(data: any, custom: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/turnTransaction', data, custom)
}
/**
 *客户关联代码
 */
export function bindARKCode(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/bindARKCode', data)
}
/**
 *根据客户代码查询关联客户信息
 */
export function queryCodeRel(arkCode: string) {
  return request.get<AxiosResult, AxiosResult>(`/lbu/api/customerCode/${arkCode}/queryCodeRel`)
}
/**
 *获取客户合同详情
 */
export function queryContractDetail(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/queryContract', data)
}
/**
 *修改合同编码
 */
export function contractCodeUpdate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/contractCodeUpdate', data)
}
/**
 *获取客户地图信息
 */
export function queryMapList(data: { addressRefId: string }) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/visitAddress/getVisitAddress', data)
}
/**
 *提交客户地图信息
 */
export function mapListSave(data: { addressRefId: string }) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/visitAddress/create', data)
}
/**
 *关联客户
 */
export function customerRelate(data: any, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/customer/relate', data, custom)
}
// 注册链接发送记录
export function registerRecordPage(data?: any) {
  return request.post<AxiosResult>('/lbu/api/register/recordPage', data)
}
// 注册链接发送记录脱敏展示
export function getRegisterDetail(params?: any) {
  return request.get<AxiosResult, AxiosResult>(`/lbu/api/register/${params}`)
}
/**
 * ************************************** 天眼查 **************************************
 */
//  查询天眼查客户列表
export function getTianyanchaCustomerList(data: TYCSearchParams) {
  return request.post<AxiosResult, AxiosResult>('/base/api/tyc/search', data)
}
